
require('./js/hacks.js');

if (typeof window !== 'undefined') {
	require('console-shim');
}

require('babel-polyfill');
require('fetch');

